'use client'

import s from './style.module.scss'
import CometLink from '@app/components/custom-links/comet-link'
import {tagPath} from '@app/[lang]/(common-header-footer)/tags/constants'
import {useSidebar} from '../sidebar-visiblity-context'
import ActiveLink from './active-link'
import clsx from 'clsx'
import {useParams, usePathname} from 'next/navigation'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {TagId} from '@app/[lang]/(common-header-footer)/tags/types'
import {LanguageCodes} from '@app/i18n/settings'
import {useTagsPageAnalytics} from '@app/[lang]/(common-header-footer)/tags/(tag-page)/[tagName]/[tagId]/get-tag-page-analytics/tag-page-analytics-context'

type Props = {
  iconSrc: string
  name: string
  nameEn: string
  href: string
  tagId: TagId
  isMobile: boolean
  emoji: string
  lang: LanguageCodes
  className?: string
}

const SidebarGameTagClient = ({iconSrc, name, nameEn, href, tagId, isMobile, emoji, lang, className}: Props) => {
  const {closeSidebar} = useSidebar()
  const params = useParams()
  const isActive = params?.tagId && tagId ? params?.tagId === tagId.toString() : false
  const {tagAnalyticsData} = useTagsPageAnalytics()

  const onClick = () => {
    if (isMobile) {
      closeSidebar()
    }
    triggerAnalytics('game-category-clicked', {
      layout: 'side-menu',
      'category-name': nameEn,
      ...tagAnalyticsData,
    }).sendAll()
  }

  return (
    <CometLink
      href={`/${tagPath}/${href}`}
      className={clsx(
        s.sidebar_tag,
        {
          [s.desktop_sidebar_tag]: !isMobile,
        },
        className,
      )}
      onClick={onClick}
    >
      <ActiveLink isActive={!!isActive} />
      {/* <Image src={iconSrc} alt={name} width={25} height={25} /> */}
      <span className={s.emoji}>{emoji}</span>
      <span
        className={clsx(s.sidebar_tag_text, 'lg:group-hover:visible lg:invisible', {
          [s.active_tag]: isActive,
          [s.hovered]: !isActive,
          [s.desktop_sidebar_tag_text]: !isMobile,
          ['group-hover:!visible !invisible']: !isMobile,
        })}
      >
        {name}
      </span>
    </CometLink>
  )
}

export default SidebarGameTagClient
